"use client"

import { useState, type ReactElement } from "react"

import { FAQ_ITEMS } from "@modules/home/components/faq"

// Story 10.7 — acordeão FAQ do `/suporte/`. Reusa o PADRÃO de acordeão da home (a11y por
// `aria-expanded`/`aria-controls`, alvo do botão ≥44px) mas consome os MESMOS 4 itens verbatim
// da produção via `FAQ_ITEMS` (fonte única — nada de Q&A fabricada ou duplicada). As secções mais
// longas da produção (Introdução/Começando/Configurando/Pagamento/Afiliados) ficam como lacuna de
// conteúdo DOCUMENTADA (não fabricada) — ver Design Note "Suporte" da spec.

export default function SupportFaq(): ReactElement {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <ul className="mx-auto flex w-full max-w-3xl flex-col gap-3">
      {FAQ_ITEMS.map((item, index) => {
        const isOpen = openIndex === index
        const panelId = `suporte-faq-panel-${index}`
        const buttonId = `suporte-faq-button-${index}`

        return (
          <li
            key={item.question}
            className="overflow-hidden rounded-[12px] border border-white/[0.07] bg-white/[0.03]"
          >
            <h3>
              <button
                id={buttonId}
                type="button"
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => setOpenIndex(isOpen ? null : index)}
                data-testid={`suporte-faq-button-${index}`}
                className="flex min-h-11 w-full items-center justify-between gap-4 px-5 py-4 text-left text-base font-semibold text-text transition-colors hover:text-accent"
              >
                <span>{item.question}</span>
                <span
                  aria-hidden="true"
                  className={`shrink-0 text-2xl leading-none text-accent transition-transform duration-200 ${
                    isOpen ? "rotate-45" : ""
                  }`}
                >
                  +
                </span>
              </button>
            </h3>
            <div
              id={panelId}
              role="region"
              aria-labelledby={buttonId}
              hidden={!isOpen}
              className="px-5 pb-5 text-sm leading-relaxed text-subtle"
            >
              {item.answer}
            </div>
          </li>
        )
      })}
    </ul>
  )
}
